import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-custom-modal',
  templateUrl: './custom-modal.component.html',
  styleUrls: ['./custom-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CustomModalComponent {
  @Input() showModal = false;
  @Input() static = false;
  @Output() showModalChange = new EventEmitter<boolean>();

  hide() {
    this.showModalChange.emit(false);
  }


}
